<h3>Looks like the site doesn't have permissions to access your camera or microphone</h3>
<p *ngIf="platform.ANDROID">Is Android: </p>
<p *ngIf="platform.IOS">Is iOS: </p>
<p *ngIf="platform.FIREFOX">Is Firefox: </p>
<p *ngIf="platform.EDGE">Is Edge: </p>
<p *ngIf="platform.SAFARI">Is Safari: </p>
<p>Default: </p>

